import React, { useEffect, useState } from 'react'
import ContactInfo from '../../components/shared/ContactInfo'
import Contacts from './Contacts'
import { useLocation } from 'react-router-dom'
import { Mail, X } from 'lucide-react'

const Footer = () => {
  const location = useLocation()
  const isLoginPage = location.pathname?.startsWith('/login')
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    setShowModal(false)
  }, [location.pathname])

  const handleClose = () => {
    setShowModal(false)
  }

  const noticeAndTermsFooter = (
    <div>
      <div>
        Owner&apos;s Edge {'\u00a9'} {new Date().getFullYear()}&nbsp;
      </div>
      <a
        href="https://www.argolimited.com/privacy"
        target="_blank"
        style={{ textDecoration: 'underline', marginLeft: '10px' }}
        rel="noreferrer"
      >
        Privacy Notice
      </a>
      <div style={{ marginLeft: '10px' }}>Use of this site is governed by </div>
      <a
        href="https://www.argolimited.com/terms-and-conditions/"
        style={{ textDecoration: 'underline' }}
      >
        Argo Group&apos;s Terms and Conditions.
      </a>
    </div>
  )

  return (
    <footer>
      <div className="container-fluid">
        {!isLoginPage ? (
          <div className="row">
            <div className="col-lg-8 col-md-8 col-sm-7 col-xs-12">
              <div style={{paddingLeft: '15px'}}>
                <ContactInfo/>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-4 col-xs-12 text-right">
              <div>
                {noticeAndTermsFooter}
              </div>
            </div>
          </div>
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'center',
              justifyContent: 'center'
            }}
          >
            {noticeAndTermsFooter}
          </div>
        )}
        <button className="contact" onClick={() => setShowModal(true)}>
          {showModal ? <X /> : <Mail />}
        </button>
        <Contacts showModal={showModal} handleClose={handleClose} />
      </div>
    </footer>
  )
}

export default Footer
